export enum BannedIPKeys {
  ID = "id",
  IP = "ip",
  BAN_DATE = "banDate",
  USER_ID = "userId",
  REASON = "reason",
}
